import React from "react";
import { websites } from "../../data";
import { CodeIcon, ExternalLinkIcon } from "@heroicons/react/solid";

export default function Websites() {
  return (
    <section id="projects" className="text-gray-300 bg-gray-950 body-font py-20">
      <div className="container px-5 mx-auto max-w-6xl">
        <div className="flex flex-col text-center w-full mb-16">
          <CodeIcon className="mx-auto inline-block w-10 h-10 text-green-400 mb-4" />
          <h2 className="sm:text-4xl text-3xl font-bold title-font mb-4 text-white">
            Featured Projects &amp; Case Studies
          </h2>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-gray-400 text-lg">
            A selection of production web applications, headless CMS platforms, and responsive client websites engineered for performance, scalability, and clean UI design.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {websites.map((project) => (
            <div
              key={project.title}
              className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 hover:border-gray-700 transition-all duration-300 flex flex-col group shadow-lg hover:shadow-xl"
            >
              <div className="relative overflow-hidden h-48 bg-gray-800">
                <img
                  alt={project.alt || project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  src={project.image}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-60"></div>
              </div>

              <div className="p-6 flex flex-col flex-grow">
                <span className="text-xs font-semibold uppercase tracking-wider text-green-400 mb-2">
                  {project.subtitle}
                </span>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-green-400 transition-colors">
                  {project.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-grow">
                  {project.description}
                </p>

                {project.tags && project.tags.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 mb-6">
                    {project.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-2.5 py-0.5 rounded bg-gray-800 text-gray-300 border border-gray-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}

                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full py-2.5 px-4 bg-gray-800 hover:bg-green-500 hover:text-white text-gray-200 text-sm font-medium rounded-lg transition-colors duration-200 mt-auto"
                >
                  Visit Website
                  <ExternalLinkIcon className="w-4 h-4 ml-2" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}